var LocaleService = /** @class */ (function () {
    function LocaleService() {
        var _a = this.fetchLocaleFromDom(), locale = _a.locale, isInPath = _a.isInPath;
        this.resolvedLocale = locale;
        this.isAddLanguageToPath = isInPath;
    }
    LocaleService.prototype.currentLocale = function () {
        return {
            locale: this.resolvedLocale || 'en',
            isInPath: this.isAddLanguageToPath || false,
        };
    };
    LocaleService.prototype.localePrefix = function () {
        return this.isAddLanguageToPath ? "/" + this.resolvedLocale : '';
    };
    LocaleService.prototype.fetchLocaleFromDom = function () {
        var locale = document.documentElement.dataset.marketLocale;
        var langInPath = document.documentElement.dataset.langInPath;
        return {
            locale: locale || 'en',
            isInPath: this.assignIsLanguageInPath(langInPath === 'true', locale || 'en'),
        };
    };
    LocaleService.prototype.assignIsLanguageInPath = function (langInPath, locale) {
        return langInPath &&
            locale.toLowerCase() !== 'en' &&
            locale.toLowerCase() !== 'en-us';
    };
    return LocaleService;
}());
export { LocaleService };
